import { Button, ButtonGroup, Modal } from '@nike/eds';

import { AlertCircle } from 'lucide-react';

export function ConfirmationModal(props: {
  isOpen: boolean;
  onConfirm: VoidFunction;
  onDismiss: VoidFunction;
  content: React.ReactNode;
  title?: string;
}) {
  const title = props.title || 'Are you sure?';
  return (
    <Modal
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      headerSlot={<h3 className='tw-text-lg tw-font-medium'>{title}</h3>}
    >
      <section className='tw-flex tw-items-center tw-gap-2'>
        <AlertCircle size={32} className='tw-text-yellow-500' />
        {props.content}
      </section>
      <ButtonGroup className='tw-mt-5 tw-justify-end'>
        <Button onClick={props.onConfirm} variant='primary'>
          Proceed
        </Button>
        <Button onClick={props.onDismiss} variant='secondary'>
          Cancel
        </Button>
      </ButtonGroup>
    </Modal>
  );
}
